import JiraConnectionsTable from './JiraConnectionsTable';
export default JiraConnectionsTable;
